import { Box, FillPreview, Text } from "@wix/design-system";
import React from "react";
import { ColorPicker } from "./color-picker";
import { SWATCH_TOGGLE } from "./data-hooks";
import { ColorPickerLiveSiteColorHint } from "./live-site-color-hint";
const ToggledColorPicker = ({
  label,
  color,
  userColors,
  onChange,
  onNewColorAdded,
  onToggle,
  isExpanded,
  dataHook,
  showColorPicker,
  colorPickerClassName,
  showResetButton,
  defaultColor,
  showLiveSiteHint
}) => {
  return /* @__PURE__ */ React.createElement("div", { "data-hook": dataHook }, /* @__PURE__ */ React.createElement(Box, { align: "space-between", marginBottom: "SP1", marginTop: "SP1", verticalAlign: "middle" }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, label), /* @__PURE__ */ React.createElement(Box, { width: "24px" }, /* @__PURE__ */ React.createElement(
    FillPreview,
    {
      content: void 0,
      fill: color || defaultColor,
      onClick: onToggle,
      dataHook: SWATCH_TOGGLE
    }
  ))), isExpanded ? /* @__PURE__ */ React.createElement(React.Fragment, null, showLiveSiteHint && /* @__PURE__ */ React.createElement(ColorPickerLiveSiteColorHint, null), /* @__PURE__ */ React.createElement(
    ColorPicker,
    {
      userColors,
      color,
      onChange,
      onNewColorAdded,
      showColorPicker,
      colorPickerClassName,
      showResetButton
    }
  )) : null);
};
export {
  ToggledColorPicker
};
//# sourceMappingURL=toggled-color-picker.js.map
